module.exports = __webpack_public_path__ + "static/media/zr_2_12.d3a3e14c.png";